import { PersonPinCircle } from "@mui/icons-material";
import { Alert, Box, Card, CardContent, CircularProgress, Grid, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import Api from "../../Api";
import { IADRole, IADUser, IUser } from "../../interfaces";
import { UserDialog } from "../UserDialog";
import { UserRoleDialog } from "../UserRoleDialog";
import './index.scss';

export const UserManager = () => {

    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState<IADUser[]>([]);
    const [roles, setRoles] = useState<IADRole[]>([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);


    const onAddUser = (userModel: IUser) => {
        Api.Users.addUser(userModel).then((response: any) => {
            Api.Users.getAll().then(userResult => {
                setUsers(userResult as IADUser[]);
                setSuccessMessage("user added");
            });
        }).catch(() => {
            setErrorMessage("failed to add user");
        }).finally(() => {
            setLoading(false);
        });
    }
    const onChangeRole = (id: string, roleId: string) => {

        setLoading(true);

        Api.Users.updateRole(id, roleId).then((response: any) => {

            if (response?.id === id) {
                let newUsers = cloneDeep(users);
                newUsers.forEach(x => {
                    if (x.id === id)
                        x.role = roles.filter(x => x?.roleId === roleId)[0];
                });
                setUsers(newUsers);
                setSuccessMessage("role updated");
            }
        }).catch(() => {
            setErrorMessage("failed to update role");
        }).finally(() => {
            setLoading(false);
        });
    }

    const headStyle = {
        fontWeight: 'bold'
    }

    useEffect(() => {

        if (users.length === 0)
            Api.Users.getAll().then(userResult => {
                setUsers(userResult as IADUser[])

                Api.Users.getRoles().then(roleResult => {
                    setRoles(roleResult as IADRole[])
                    setLoading(false);
                });
            });
    })

    return (
        <>
            {loading ? <Box textAlign="center" sx={{ opacity: .4, mt: 10 }}><CircularProgress /></Box> :
                <Card>
                    <CardContent>
                        <Grid item xs={12}>
                            <Table size="small" >

                                <TableHead >
                                    <TableRow >
                                        <TableCell sx={headStyle}>Display Name</TableCell>
                                        <TableCell />
                                        <TableCell sx={headStyle}>Username</TableCell>
                                        <TableCell sx={headStyle}>Role</TableCell>
                                        <TableCell />


                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {users.map(x => (
                                        <TableRow key={x.id}>
                                            <TableCell>
                                                {x.name} </TableCell>
                                            <TableCell>
                                                {x.type.toUpperCase() === "GUEST" && <Tooltip title="Guest user">
                                                    <Typography sx={{ opacity: .8, display: 'inline' }} color="primary">
                                                        <PersonPinCircle />

                                                    </Typography>
                                                </Tooltip>}
                                            </TableCell>
                                            <TableCell>{x.email}</TableCell>

                                            <TableCell>{x.role?.name}</TableCell>
                                            <TableCell>
                                                <UserRoleDialog
                                                    user={x}
                                                    roles={roles}
                                                    onSubmitRole={(roleId: string) => onChangeRole(x.id, roleId)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <UserDialog
                                roles={roles}
                                onSubmitUser={(user: IUser) => onAddUser(user)}
                            />

                            <Snackbar
                                sx={{ mt: 10 }}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={errorMessage !== null}
                                autoHideDuration={6000}
                                onClose={() => setErrorMessage(null)}>
                                <Alert severity="error">{errorMessage}</Alert>
                            </Snackbar>

                            <Snackbar
                                sx={{ mt: 10 }}
                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                open={successMessage !== null}
                                autoHideDuration={6000}
                                onClose={() => setSuccessMessage(null)}>
                                <Alert severity="success">{successMessage}</Alert>
                            </Snackbar>
                        </Grid>
                    </CardContent>
                </Card>

            }


        </>
    );

}